import { Card, Grid, Switch, TagsInput, Text } from '@mantine/core';

const availableLocales = ['en', 'bg'];

const SearchAsYouTypeBlockedTab = ({ search, handleSearchChange, domain }) => {
  const disableLocaleBlocked = !availableLocales.includes(domain.locale);

  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md" data-tour="searchAsYouType">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Use locale defaults</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Switch
              name="localeBlocked"
              checked={search.localeBlocked}
              disabled={disableLocaleBlocked}
              onChange={handleSearchChange}
            />
            <Text size="xs" c="dimmed" mt="xs">
              {disableLocaleBlocked
                ? 'Your domain locale does not have this feature.'
                : 'Filter all of words that are insignificant like: The, a, and ect. Based on your domain locale'}
            </Text>
          </Grid.Col>
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Blocked words</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <TagsInput
              clearable
              data={[]}
              value={search.blocked || []}
              onChange={(blocked) => handleSearchChange({ target: { name: 'blocked', value: blocked } })}
              placeholder="Add new blocked words for your search..."
            />
            <Text size="xs" c="dimmed" mt="xs">
              Terms that will be filtered from search suggestions and results.
            </Text>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SearchAsYouTypeBlockedTab;
